import { CLIENT_NAME } from "../../constants";
import { CALL_API } from "../api.middleware";
import {
	GET_CART_ITEMS_LIST,
	GET_CART_ITEMS_LIST_SUCCESS,
	GET_CART_ITEMS_LIST_FAILED,
	DELETE_CART_ITEMS_LIST,
	DELETE_CART_ITEMS_LIST_SUCCESS,
	DELETE_CART_ITEMS_LIST_FAILED,
	ADD_TO_CART,
	ADD_TO_CART_SUCCESS,
	ADD_TO_CART_FAILED,
	FETCH_CART_ITEM,
	FETCH_CART_ITEM_SUCCESS,
	FETCH_CART_ITEM_FAILED,
	DELETE_CART_ITEM,
	DELETE_CART_ITEM_SUCCESS,
	DELETE_CART_ITEM_FAILED,
	UPLOAD_CART_IMAGES,
	UPLOAD_CART_IMAGES_SUCCESS,
	UPLOAD_CART_IMAGES_FAILED,
	AVAILABLE_DATES,
	AVAILABLE_DATES_SUCCESS,
	AVAILABLE_DATES_FAILED,
	AVAILABLE_SLOTS,
	AVAILABLE_SLOTS_SUCCESS,
	AVAILABLE_SLOTS_FAILED,
	BOOKING_IMAGE,
	BOOKING_IMAGE_SUCCESS,
	BOOKING_IMAGE_FAILED,
	APPLY_OFFER_CODE,
	APPLY_OFFER_CODE_SUCCESS,
	APPLY_OFFER_CODE_FAILED,
	GET_MULTI_SERVICE_DETAILS,
	GET_MULTI_SERVICE_DETAILS_SUCCESS,
	GET_MULTI_SERVICE_DETAILS_FAILED,
	DELETE_CART_IMAGE,
	DELETE_CART_IMAGE_SUCCESS,
	DELETE_CART_IMAGE_FAILED,
	UPDATE_CART_ITEM,
	UPDATE_CART_ITEM_SUCCESS,
	UPDATE_CART_ITEM_FAILED,
	LOGOUT_SUCCESS,
	SAVE_SERVICE_DATA,
	STORE_CITY_SUCCESS,
	INSERT_IMAGE_INTO_CART,
	DELETE_IMAGE_FROM_CARTIMAGES,
} from "../Types";

export const getCartItemsList = () => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/cart`,
				method: "GET",
				types: [
					GET_CART_ITEMS_LIST,
					GET_CART_ITEMS_LIST_SUCCESS,
					GET_CART_ITEMS_LIST_FAILED,
				],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 58", error);
	}
};

export const deleteCartItemList = () => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/cart`,
				method: "DELETE",
				types: [
					DELETE_CART_ITEMS_LIST,
					DELETE_CART_ITEMS_LIST_SUCCESS,
					DELETE_CART_ITEMS_LIST_FAILED,
				],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 78", error);
	}
};

export const addItemToCart = (payload) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/cart/items`,
				method: "POST",
				body: payload,
				types: [ADD_TO_CART, ADD_TO_CART_SUCCESS, ADD_TO_CART_FAILED],
				showLoader: true,
				showToast: true,
				toastMessage: "Item added successfully",
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 97", error);
	}
};

export const fetchCartItem = (id) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/cart/items/${id}`,
				method: "GET",
				types: [FETCH_CART_ITEM, FETCH_CART_ITEM_SUCCESS, FETCH_CART_ITEM_FAILED],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 113", error);
	}
};

export const deleteCartItem = (id) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/cart/items/${id}`,
				method: "DELETE",
				types: [DELETE_CART_ITEM, DELETE_CART_ITEM_SUCCESS, DELETE_CART_ITEM_FAILED],
				showLoader: true,
				showToast: true,
				toastMessage: "Item deleted successfully",
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 131", error);
	}
};

export const applyOfferCode = (code) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/cart`,
				method: "PATCH",
				body: code,
				types: [APPLY_OFFER_CODE, APPLY_OFFER_CODE_SUCCESS, APPLY_OFFER_CODE_FAILED],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 148", error);
	}
};

export const uploadCartImage = (id, body) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/cart/items/${id}/images`,
				method: "POST",
				types: [
					UPLOAD_CART_IMAGES,
					UPLOAD_CART_IMAGES_SUCCESS,
					UPLOAD_CART_IMAGES_FAILED,
				],
				body,
				isForm: true,
				showLoader: true,
				showToast: true,
				toastMessage: "Image uploaded successfully",
				additionalData: { id },
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 169", error);
	}
};

export const getDates = () => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/calendar/available-dates`,
				method: "GET",
				types: [AVAILABLE_DATES, AVAILABLE_DATES_SUCCESS, AVAILABLE_DATES_FAILED],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Cart - 185", error);
	}
};

export const getTimeSlots = (date, workshopId) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/calendar/available-slots?date=${date}&workshopId=${workshopId}`,
				method: "GET",
				types: [AVAILABLE_SLOTS, AVAILABLE_SLOTS_SUCCESS, AVAILABLE_SLOTS_FAILED],
				showLoader: false,
			},
		});
	} catch (error) {
		console.error("Cart - 200", error);
		return { error };
	}
};

export const uploadBookingImages_ALL = (id, body) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}/images`,
				method: "POST",
				types: [BOOKING_IMAGE, BOOKING_IMAGE_SUCCESS, BOOKING_IMAGE_FAILED],
				body,
				isForm: true,
				showLoader: true,
				showToast: true,
				toastMessage: "Image uploaded successfully",
				additionalData: { id },
			},
		});
	} catch (error) {
		// alert("B206 = " + `${error}`);
		console.error("Book - 213", error);
	}
};

export const getMultiServiceData =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: `/catalog/multi-service`, //?serviceIdList=${body}&clientName=${CLIENT_NAME}`,
					method: "GET",
					types: [
						GET_MULTI_SERVICE_DETAILS,
						GET_MULTI_SERVICE_DETAILS_SUCCESS,
						GET_MULTI_SERVICE_DETAILS_FAILED,
					],
					showLoader: true,
					additionalData: {
						showError: false,
					},
					params,
				},
			});
		} catch (error) {
			console.error("Cart - 223", error);
			return { error };
		}
	};

export const deleteCartImage =
	(id, params = {}) =>
	async (dispatch) => {
		try {
			await dispatch({
				[CALL_API]: {
					url: `/transaction/cart/items/${id}/images`,
					method: "DELETE",
					types: [DELETE_CART_IMAGE, DELETE_CART_IMAGE_SUCCESS, DELETE_CART_IMAGE_FAILED],
					params,
					showLoader: true,
					showToast: true,
					toastMessage: "Image deleted successfully",
					additionalData: params,
				},
			});
		} catch (error) {
			console.error("Cart - 245", error);
			return { error };
		}
	};

export const updateCartItem = (id, body) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/cart/items/${id}`,
				method: "PUT",
				types: [UPDATE_CART_ITEM, UPDATE_CART_ITEM_SUCCESS, UPDATE_CART_ITEM_FAILED],
				body,
				showLoader: true,
				showToast: true,
				toastMessage: "Cart item updated successfully",
				additionalData: { body },
			},
		});
	} catch (error) {
		console.error("Cart - 265", error);
		return { error };
	}
};

export const storeUserCurrentCity = (city) => {
	return {
		currentCity: city,
		type: STORE_CITY_SUCCESS,
	};
};

export function logout() {
	return {
		type: LOGOUT_SUCCESS,
	};
}
export const saveServiceData = (data) => {
	return {
		serviceData: data,
		type: SAVE_SERVICE_DATA,
	};
};

export const insertCartImagesIntoCartItems = (imgArr, id) => {
	return {
		imagesArr: imgArr,
		itemId: id,
		type: INSERT_IMAGE_INTO_CART,
	};
};

export const deleteImagesFromCartImages = (imgArr, id) => {
	return {
		imagesArr: imgArr,
		itemId: id,
		type: DELETE_IMAGE_FROM_CARTIMAGES,
	};
};
